_ = require 'underscore'

module.exports = class LimitMixin

  isOverLimit: (limitName, limitType) ->
    limits = @get('limits')

    if !limits?
      # Fail open, the server will reject if we're over
      return false

    _.chain(limits)
    .pairs()
    .any ([key, data]) =>
      status = data[limitType]?.status
      key.indexOf(limitName) == 0 && (status == 'disabled' || status == 'maxExceeded')
    .value()



// WEBPACK FOOTER //
// ./app/scripts/lib/limit-mixin.coffee